<bgo-home-banner></bgo-home-banner>
<bgo-home-page-content
  [content]="page.content"
  (howItWorksCtaClicked)="openSearch()"
  (reviewCtaClicked)="navigateToAboutUsPage()"
  class="mt-2xl md:mt-3xl"
></bgo-home-page-content>
